import DOMPurify from 'dompurify';

/* eslint-disable no-underscore-dangle */
document.addEventListener('DOMContentLoaded', () => {
  let page = 1;
  const loadMoreButton = document.getElementById('plarium-news-load-more');
  const loadMoreText = document.getElementsByClassName('plarium-load-more__button__load')[0];
  const loadingText = document.getElementsByClassName('plarium-load-more__button__loading')[0];
  const postContainer = document.getElementById('news-grid');

  /**
   * Fetches news posts
   * @param {number} pageNumber - The page number, 1 is already rendered in PHP so first fetch is for 2.
   */
  const fetchPosts = (pageNumber) => {
    loadMoreText.style.display = 'none';
    loadingText.style.display = 'block';
    // this is is defined in the wp_localize_script
    // eslint-disable-next-line no-undef
    fetch(`${news_load_more_params.ajaxurl}/news?page=${pageNumber}&per_page=6&_embed`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // eslint-disable-next-line no-undef
        'X-WP-Nonce': news_load_more_params.nonce,
      },
    })
      .then((response) => {
        const totalPages = parseInt(response.headers.get('x-wp-totalpages'), 10);
        response.json().then((posts) => {
          if (posts.length) {
            posts.forEach((post) => {
              const postElement = document.createElement('article');
              postElement.classList.add('news-article');
              const featuredMedia = post._embedded?.['wp:featuredmedia']?.[0] || null;
              const featuredImage = featuredMedia
                ? `<img class="news-article__image" src="${featuredMedia.source_url}" alt="${featuredMedia.alt_text}" />`
                : '';
              const postDate = new Date(post.date);
              const formattedDate = `${postDate.getDate()}/${
                postDate.getMonth() + 1
              }/${postDate.getFullYear()}`;
              postElement.innerHTML = DOMPurify.sanitize(
                `
                    <a href="${post.link}">
                       ${featuredImage}
                      <h3 class="news-article__title">${post.title.rendered}</h3>
                      <span class="news-article__date">
                         ${formattedDate}
                      </span>
                      <div class="news-article__excerpt">
                        <p>
                          ${post.excerpt.rendered}
                        </p>
                      </div>
                    </a>
                `,
                { USE_PROFILES: { html: true } },
              );
              postContainer.appendChild(postElement);
            });
          } else {
            loadMoreButton.style.display = 'none';
          }
        });
        return totalPages;
      })
      .then((totalPages) => {
        if (pageNumber < totalPages) {
          loadMoreText.style.display = 'block';
        }
        loadingText.style.display = 'none';
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching posts in news archive:', error);
      });
  };

  loadMoreButton.addEventListener('click', () => {
    page += 1;
    fetchPosts(page);
  });
});
